<template>
  <v-app>
    <v-container fluid class="pa-0">


      <!-- HEADER -->
      <div class="bckg">
        <div style="display:flex; align-items:center; gap:20px;">
          <v-tooltip location="bottom">
            <template #activator="{ props }">
              <router-link to="/home" v-bind="props">
                <img :src="headerImage" alt="Header" class="header-image" />
              </router-link>
            </template>
            ProASSETO
          </v-tooltip>
          <InventoryNav_Main style="margin-top: 1px;" />
        </div>

        <!-- GORNJI DESNI UGAO SA KORISNIKOM I DUGMADIMA -->
        <div class="top-right">
          <!-- pomocni meni-->
          <template v-if="RoleId == 1 || RoleId == 2">
            <v-menu open-on-hover offset-y transition="scale-transition">
              <template #activator="{ props }">
                <span class="color-text" v-bind="props">
                  {{ Initials }}
                </span>
              </template>

              <v-list class="custom-dropdown">
                <v-list-item>
                  <LangSwitcher />
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item v-if="RoleId == 1" to="/superadmin/clients" link>
                  <v-list-item-title class="menu-link">{{ $t('navmenuAdmin.klijenti') }}</v-list-item-title>
                </v-list-item>

                <v-divider v-if="RoleId == 1"></v-divider>

                <v-list-item to="/control-panel" link>
                  <v-list-item-title class="menu-link">{{ $t('navmenuAdmin.kontrolniPanel') }}</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item v-if="RoleId == 2 || RoleId == 3" @click="openPasswordModal" link>
                  <v-list-item-title class="menu-link">{{ $t('navmenuAdmin.personalData') }}</v-list-item-title>
                </v-list-item>

                <v-divider v-if="RoleId == 2 || RoleId == 3"></v-divider>

                <v-list-item v-if="RoleId == 2" @click="previewFile(uputstvoUrl)" target="_blank" link>
                  <v-list-item-title class="menu-link">{{ $t('navmenuAdmin.uputstvo') }}</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="logout" link>
                  <v-list-item-title class="menu-link-error">{{ $t('navmenuAdmin.odjava') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-else>
            <v-menu open-on-hover offset-y transition="scale-transition">
              <template #activator="{ props }">
                <span class="color-text" v-bind="props">
                  {{ Initials }}
                </span>
              </template>

              <v-list class="custom-dropdown">
                <v-list-item>
                  <LangSwitcher />
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="openPasswordModal" link>
                  <v-list-item-title class="menu-link">{{ $t('navmenuAdmin.personalData') }}</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="previewFile(uputstvoKorisnikUrl)" link>
                  <v-list-item-title class="menu-link">{{ $t('navmenuAdmin.uputstvo') }}</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item @click="logout" link>
                  <v-list-item-title class="menu-link-error">{{ $t('navmenuAdmin.odjava') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>


        </div>

      </div>

      <!-- SUPERADMIN TRAKA -->
      <div v-if="RoleId == 1 && selectedCompany" class="superadmin-bar">
        <span class="superadmin-bar-text">
          <v-icon size="14" style="margin-right:6px; opacity:0.8;">mdi-domain</v-icon>
          {{ selectedCompany.Name }}
          <template v-if="selectedCompany.Shorts"> &nbsp;-&nbsp; {{ selectedCompany.Shorts }}</template>
          ,&nbsp; {{ selectedCompany.CountryName }}
        </span>
        <span class="superadmin-bar-change" @click="companyModal = true">
          <v-icon size="14" style="margin-right:4px;">mdi-swap-horizontal</v-icon>
          {{ $t('navmenuAdmin.promijeniKlijenta') }}
        </span>
      </div>

      <!-- SUPERADMIN MODAL -->
      <BaseModal v-if="RoleId == 1" v-model="companyModal" :title="$t('navmenuAdmin.izaberiKlijentaUPPER')" size="md"
        :persistent="true">
        <v-select v-model="selectedCountryId" :items="countries" item-title="Name" item-value="Id"
          :label="$t('navmenuAdmin.zemlja')" density="comfortable" class="mb-3" hide-details />
        <v-select v-model="selectedCompanyId" :items="filteredCompanies" item-title="Name" item-value="Id"
          :label="$t('navmenuAdmin.firma')" density="comfortable" hide-details :disabled="!selectedCountryId" />

        <template #footer>
          <div class="d-flex justify-end ga-2">
            <v-btn color="primary" variant="flat" :disabled="!selectedCompanyId" @click="confirmCompany">
              <span style="font-size:14px; font-weight:600;">{{ $t('general.potvrdi') }}</span>
            </v-btn>
          </div>
        </template>
      </BaseModal>

      <!-- PASSWORD CHANGE MODAL -->
      <BaseModal v-model="passwordModal" :title="$t('navmenuAdmin.personalData') + ' - ' + $t('general.promjenaSifre')"
        size="md" @hidden="onPasswordModalHidden">
        <v-form ref="passwordForm" v-model="passwordValid" @submit.prevent="changePassword">
          <v-text-field v-model="currentPassword" :label="$t('navmenuAdmin.currentPassword')"
            :type="showCurrentPassword ? 'text' : 'password'" :rules="passwordRules" required density="comfortable"
            class="mb-3">
            <template v-slot:append-inner>
              <v-icon :icon="showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye'" tabindex="-1"
                @click="showCurrentPassword = !showCurrentPassword" />
            </template>
          </v-text-field>

          <v-text-field v-model="newPassword" :label="$t('navmenuAdmin.newPassword')"
            :type="showNewPassword ? 'text' : 'password'" :rules="newPasswordRules" required density="comfortable"
            class="mb-3">
            <template v-slot:append-inner>
              <v-icon :icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'" tabindex="-1"
                @click="showNewPassword = !showNewPassword" />
            </template>
          </v-text-field>

          <v-text-field v-model="confirmPassword" :label="$t('navmenuAdmin.confirmPassword')"
            :type="showConfirmPassword ? 'text' : 'password'" :rules="confirmPasswordRules" required
            density="comfortable" class="mb-3">
            <template v-slot:append-inner>
              <v-icon :icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'" tabindex="-1"
                @click="showConfirmPassword = !showConfirmPassword" />
            </template>
          </v-text-field>

        </v-form>

        <template #footer>
          <div class="d-flex justify-end ga-2">
            <v-btn variant="outlined" @click="closePasswordModal">
              <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
            </v-btn>
            <v-btn color="primary" variant="flat" :loading="passwordLoading" :disabled="!passwordValid"
              @click="changePassword">
              <span style="font-size:14px; font-weight:600;">{{ $t('general.potvrdi') }}</span>
            </v-btn>
          </div>
        </template>
      </BaseModal>

      <!-- PREGLED UPUTSTVA -->
      <BaseModal v-model="docPreviewDialog" size="xl" height="90vh" :title="$t('general.pregledUputstva')"
        modalClass="report-modal" :hideFooter="true" @update:modelValue="val => { if (!val) closeDocPreview() }">
        <template #header-actions>
          <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.download')">
            <template #activator="{ props }">
              <v-btn v-bind="props" icon variant="plain" @click="downloadDoc">
                <v-icon size="18" style="padding-left: 10px;">mdi-download</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
          <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.print')">
            <template #activator="{ props }">
              <v-btn v-bind="props" icon variant="plain" @click="printDoc">
                <v-icon size="18">mdi-printer</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </template>
        <!-- LOADER -->
        <div v-if="docPreviewLoading" style="display:flex; align-items:center; justify-content:center; height:100%;">
          <v-progress-circular indeterminate color="primary" size="48" />
        </div>
        <iframe ref="documentFrame" style="width:100%; height:100%; border:none;" />
      </BaseModal>
      <!-- Horizontalni meni 
      <InventoryNav />-->

      <!-- Glavni sadržaj stranice -->
      <router-view />

      <!-- FOOTER 
      <div class="text-center mt-4 pb-4">
        <small>2025. © Design and developement. All rights reserved.</small>
      </div>-->

      <!-- Loader overlay -->
      <div v-if="loadingOverlay" class="lang-loader-overlay">
        <div class="lang-loader-spinner" />
      </div>
    </v-container>
  </v-app>
</template>

<script>
import LangSwitcher from '@/components/LanguageSwitcher.vue'
import InventoryNav_Main from "@/components/InventoryNav_Main.vue";
import headerImage from "@/assets/header-asset.png";
import BaseModal from '@/components/dialogs/BaseModal.vue';

export default {
  name: "DefaultLayout",
  components: {
    InventoryNav_Main,
    LangSwitcher,
    BaseModal
  },
  data() {
    return {
      docPreviewLoading: false,
      docPreviewDialog: false,
      docPreviewUrl: null,
      docPreviewFileName: null,
      docPreviewBlob: null,
      countries: [],
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      headerImage,
      RoleId: localStorage.getItem("RoleId"),
      companyModal: false,
      allCompanies: [],
      selectedCountryId: null,
      selectedCompanyId: null,
      selectedCompany: null,
      loadingOverlay: false,
      passwordModal: false,
      passwordValid: false,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      passwordLoading: false
    };
  },
  computed: {
    Initials() {
      const initials = localStorage.getItem("Initials") || ""
      const isCyrillic = this.$i18n.locale === 'sr' || this.$i18n.locale === 'cir-ekavica'

      const toLat = {
        'А': 'A', 'Б': 'B', 'Ц': 'C', 'Д': 'D', 'Е': 'E', 'Ф': 'F', 'Г': 'G',
        'Х': 'H', 'И': 'I', 'Ј': 'J', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
        'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U', 'В': 'V', 'З': 'Z',
        'Ч': 'Č', 'Ћ': 'Ć', 'Ш': 'Š', 'Ж': 'Ž', 'Ђ': 'Đ'
      }
      const toCir = {
        'A': 'А', 'B': 'Б', 'C': 'Ц', 'D': 'Д', 'E': 'Е', 'F': 'Ф', 'G': 'Г',
        'H': 'Х', 'I': 'И', 'J': 'Ј', 'K': 'К', 'L': 'Л', 'M': 'М', 'N': 'Н',
        'O': 'О', 'P': 'П', 'R': 'Р', 'S': 'С', 'T': 'Т', 'U': 'У', 'V': 'В', 'Z': 'З',
        'Č': 'Ч', 'Ć': 'Ћ', 'Š': 'Ш', 'Ž': 'Ж', 'Đ': 'Ђ'
      }

      // Prvo konvertuj sve u latinicu
      const latinInitials = initials.split('').map(c => toLat[c] || c).join('')

      if (isCyrillic) {
        return latinInitials.split('').map(c => toCir[c.toUpperCase()] || c).join('')
      }
      return latinInitials
    },
    uputstvoUrl() {
      const countryId = Number(localStorage.getItem('CountryId'))
      if (countryId === 3) return 'UputstvoAdministrator_SRB.pdf'
      if (countryId === 2) return 'UputstvoAdministrator_ENG.pdf'
      return 'UputstvoAdministrator_BH.pdf'
    },
    uputstvoKorisnikUrl() {
      const countryId = Number(localStorage.getItem('CountryId'))
      if (countryId === 3) return 'UputstvoKorisnik_SRB.pdf'
      if (countryId === 2) return 'UputstvoKorisnik_ENG.pdf'
      return 'UputstvoKorisnik_BH.pdf'
    },
    filteredCompanies() {
      if (!this.selectedCountryId) return []
      return this.allCompanies.filter(c => c.CountryId === this.selectedCountryId)
    },
    passwordRules() {
      return [
        v => !!v || this.$t('validation.required'),
      ]
    },
    newPasswordRules() {
      return [
        v => !!v || this.$t('validation.required'),
        v => v.length >= 6 || this.$t('navmenuAdmin.passwordMinLength'),
        v => /[A-Z]/.test(v) || this.$t('navmenuAdmin.passwordUppercase'),
        v => /[a-z]/.test(v) || this.$t('navmenuAdmin.passwordLowercase'),
        v => /[^A-Za-z0-9]/.test(v) || this.$t('navmenuAdmin.passwordSpecial'),
      ]
    },
    confirmPasswordRules() {
      return [
        v => !!v || this.$t('validation.required'),
        v => v === this.newPassword || this.$t('navmenuAdmin.passwordMismatch'),
      ]
    }
  },

  watch: {
    selectedCountryId(newVal) {
      const companies = this.allCompanies.filter(c => c.CountryId === newVal)
      const first = companies.length ? companies.reduce((min, c) => c.Id < min.Id ? c : min, companies[0]) : null
      this.selectedCompanyId = first ? first.Id : null

    }
  },
  async mounted() {
    if (this.RoleId == 1) {
      await this.fetchCompanies()
      const savedId = Number(localStorage.getItem('CompanyId'))
      if (savedId) {
        const found = this.allCompanies.find(c => String(c.Id) === String(savedId))
        if (found) {
          this.selectedCompany = found
          this.selectedCountryId = found.CountryId
          this.selectedCompanyId = found.Id
          localStorage.setItem('CompanyHeader', found.Header || '')
        } else {
          // CompanyId postoji ali firma nije pronađena — postavi prvu dostupnu
          this.selectedCompany = this.allCompanies[0] || null
        }
        // NE otvaraj modal ako CompanyId postoji
      } else {
        this.companyModal = true
      }
    }
  },
  methods: {
    async previewFile(fileName) {
      this.currentFileName = fileName
      this.docPreviewLoading = true
      this.docPreviewDialog = true
      try {
        const response = await this.$axios.get('Upload?fileName=' + fileName + '&folder=' + 'Dokumenti', { responseType: 'arraybuffer' })
        const isImage = /\.(png|jpg|jpeg|webp|gif)$/i.test(fileName)
        const mimeType = isImage ? 'image/' + fileName.split('.').pop().toLowerCase() : 'application/pdf'
        const blob = new Blob([response.data], { type: mimeType })
        this.currentFileUrl = window.URL.createObjectURL(blob)

        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs.documentFrame) {
              this.$refs.documentFrame.src = this.currentFileUrl
              this.$refs.documentFrame.onload = () => {
                this.docPreviewLoading = false
              }
            }
          })
        })
      } catch (err) {
        console.error(err)
        this.docPreviewLoading = false
      }
    },
    /*
        async openDoc(url) {
          try {
            const res = await fetch(url)
            if (!res.ok) throw new Error(this.$t('User_message.m149'))
            const blob = await res.blob()
            this.docPreviewUrl = window.URL.createObjectURL(blob)
            this.docPreviewFileName = url.split('/').pop()
            this.docPreviewBlob = blob
            this.docPreviewDialog = true
          } catch (err) {
            console.error(err)
          }
        },
    */
    downloadDoc() {
      if (!this.docPreviewUrl) return
      const link = document.createElement('a')
      link.href = this.docPreviewUrl
      link.setAttribute('download', this.docPreviewFileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    printDoc() {
      this.$refs.docPreviewFrame?.contentWindow?.print()
    },

    closeDocPreview() {
      if (this.docPreviewUrl) window.URL.revokeObjectURL(this.docPreviewUrl)
      this.docPreviewDialog = false
      this.docPreviewUrl = null
      this.docPreviewFileName = null
      this.docPreviewBlob = null
    },
    async fetchCompanies() {
      try {
        const lang = localStorage.getItem('lang')
        const isCyrillic = lang === 'sr' || lang === 'cir-ekavica'

        const [companiesRes, countriesRes] = await Promise.all([
          this.$axios.get('SuperAdmin', { params: { languageId: isCyrillic ? 1 : 2 } }),
          this.$axios.get('Country/Show', { params: { languageId: isCyrillic ? 1 : 2 } })
        ])
        this.allCompanies = companiesRes.data || []
        this.countries = countriesRes.data || []
      } catch (err) {
        console.error(err)
      }
    },
    confirmCompany() {
      const company = this.allCompanies.find(c => c.Id === this.selectedCompanyId)
      if (!company) return

      this.selectedCompany = company
      localStorage.setItem('CompanyId', company.Id)
      localStorage.setItem('CompanyHeader', company.Header || '')
      this.companyModal = false
      this.loadingOverlay = true
      window.location.reload()
    },
    logout() {
      localStorage.removeItem("Token");
      localStorage.removeItem("username");
      localStorage.clear()
      window.location.href = "/";
    },
    openPasswordModal() {
      this.passwordModal = true
    },
    closePasswordModal() {
      this.passwordModal = false
    },
    onPasswordModalHidden() {
      this.currentPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.passwordValid = false
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.reset()
      }
    },
    async changePassword() {
      if (!this.$refs.passwordForm.validate()) return;

      this.passwordLoading = true;

      try {
        const response = await this.$axios.put('User/ChangePassword', {
          CurrentPassword: this.currentPassword,
          NewPassword: this.newPassword,
          Id: Number(localStorage.getItem("UserId")),
          CompanyId: Number(localStorage.getItem("CompanyId"))
        });

        if (response.status === 200) {
          if (response.data == "WRONG PASS") {//pogresna stara sifra
            this.$store.dispatch("NOTIF_WARNING", {
              poruka: this.$t('general.wrongCurrentPassword'),
              position: "center",
              icon: "error",
              timer: 4500,
              width: "550"
            });

          }
          else {// Uspješna promjena šifre
            this.$store.dispatch("NOTIF_SUCCESS", {
              poruka: this.$t('navmenuAdmin.passwordChanged'),
              position: "top-end",
              timer: 2500,
              action: "noreload"
            });
            this.closePasswordModal();
            setTimeout(() => {
              localStorage.clear()
              window.location.href = "/"
            }, 2500)
          }

        }
      } catch (error) {
        console.error(error);
        this.$store.dispatch("NOTIF_WARNING", {
          poruka: error.response?.data?.message || this.$t('navmenuAdmin.errorChangingPassword'),
          position: "center",
          icon: "error",
          timer: 4500,
          width: "550"
        });
      } finally {
        this.passwordLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.lang-loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.lang-loader-spinner {
  width: 48px;
  height: 48px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.header-image {
  margin-left: 15px;
  max-height: 60px;
  object-fit: contain;
}

.top-right {
  position: absolute;
  top: 8px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.bckg {
  display: flex;
  height: 48px;
  background-color: #152854;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;
}

.color-text {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border-radius: 50%;
  background-color: white;
  color: #000;
  /* ili boja po želji */

  font-weight: 600;
  font-size: 13px;

  border: 1px solid #e0e0e0;

  margin-top: 0px;
}

.menu-link {
  color: rgba(255, 255, 255, 0.9) !important;
  padding: 8px 5px !important;
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  transition: all 0.2s ease;
}

.menu-link:hover {
  color: #ffffff !important;
}

.custom-dropdown {
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  padding: 0 !important;
  border: 1px solid #eef1f5;
  background-color: #142854 !important;
  color: white;
}

.menu-link-error {
  color: rgba(231, 5, 5, 0.9) !important;
  padding: 8px 5px !important;
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  transition: all 0.2s ease;
}

.menu-link-error:hover {
  color: #E70505 !important;
}

.custom-dropdown .v-divider {
  margin-top: 0px;
  margin-bottom: 0px;
}

.superadmin-bar {
  background-color: #1e3f7a;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 25px 20px 25px 20px;
}

.superadmin-bar-text {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
}

.superadmin-bar-change {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.694);
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.superadmin-bar-change:hover {
  color: white;

}

.superadmin-bar-change:hover {
  color: rgba(255, 255, 255, 0.9);
}
</style>
